
const state = {
  id: null,
  key: '',
  title: '',
}

export const requiredFields = [
  { key: 'key' },
  { key: 'title' },
]

export default state
